import { render } from "./Finalizar.vue?vue&type=template&id=4cdb230a&scoped=true"
import script from "./Finalizar.vue?vue&type=script&lang=js"
export * from "./Finalizar.vue?vue&type=script&lang=js"

import "./Finalizar.vue?vue&type=style&index=0&id=4cdb230a&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdb230a"]])

export default __exports__